import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  sidebarPinned: boolean;
  toggleSidebarPin: () => void;
  setSidebarPinned: (pinned: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarPinned: true,
      toggleSidebarPin: () => set((s) => ({ sidebarPinned: !s.sidebarPinned })),
      setSidebarPinned: (pinned) => set({ sidebarPinned: pinned }),
    }),
    { name: 'wmos-ui' }
  )
);
